import MuiRadioGroup, {
  type RadioGroupProps as MuiRadioGroupProps,
} from '@mui/material/RadioGroup';
import classNames from 'classnames';

import { ErrorMessage } from '../../ErrorMessage';

export interface RadioGroupProps extends MuiRadioGroupProps {
  errors?: string | string[];
  fullWidth?: boolean;
  className?: string;
  loading?: boolean;
}

export const RadioGroup = ({
  children,
  className,
  errors,
  fullWidth = true,
  ...props
}: RadioGroupProps) => {
  return (
    <div
      className={classNames(
        {
          'w-full': fullWidth,
        },
        className,
      )}
    >
      {errors && <ErrorMessage className="mt-1" errors={errors} />}
      <MuiRadioGroup {...props}>{children}</MuiRadioGroup>
    </div>
  );
};
